// import Swiper JS
import Swiper from "swiper";
// import Swiper styles
import "swiper/css/effect-fade";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
// import Swiper modules
import {
  EffectFade,
  Autoplay,
  Navigation,
  Pagination,
  Scrollbar,
  Thumbs,
} from "swiper/modules";
// import Swiper core styles
import "swiper/css";

// // 上記はブラウザ環境では削除
// export async function initSwiper(){

//   /**---------------------------------------------
//    * fadeエフェクトの場合は、loopプロパティはfalseにする
//   **-----------------------------------------------*/
//   const swiper = new Swiper('.swiper',{
//     modules: [EffectFade, Autoplay],// ← ブラウザ環境では削除
//     keyboard: { enabled: false },
//     mousewheel: { enabled: false },
//     autoplay: {
//       delay: 5000,
//     },
//     speed: 1000,
//     effect: 'fade', // ← フェード切り替えを有効にする
//     fadeEffect: {
//       crossFade: true, // ← スライドを完全に切り替える（true推奨）
//     },
//     //loopPreventsSlide: false,
//     on: {
//       slideChangeTransitionStart: function () {
//         //console.log('スライド変更開始:', this.realIndex); // スライドが切り替わり始めた瞬間
//       },
//       slideChangeTransitionEnd: function () {
//         //console.log('スライド変更完了:', this.realIndex); // スライド変更が完了した後
//       }
//     }
//   });
// }

export async function initFadeSwiper() {
  document.querySelectorAll(".swiper-fade").forEach((el) => {
    /**---------------------------------------------
     * fadeエフェクトの場合は、loopプロパティはfalseにする
     **-----------------------------------------------*/
    new Swiper(el, {
      modules: [EffectFade, Autoplay], // ← ブラウザ環境では削除
      keyboard: { enabled: false },
      mousewheel: { enabled: false },
      autoplay: {
        delay: 5000,
      },
      speed: 1000,
      effect: "fade", // ← フェード切り替えを有効にする
      fadeEffect: {
        crossFade: true, // ← スライドを完全に切り替える（true推奨）
      },
      //loopPreventsSlide: false,
      on: {
        slideChangeTransitionStart: function () {
          //console.log('スライド変更開始:', this.realIndex); // スライドが切り替わり始めた瞬間
        },
        slideChangeTransitionEnd: function () {
          //console.log('スライド変更完了:', this.realIndex); // スライド変更が完了した後
        },
      },
    });
  });
}

// 上記はブラウザ環境では削除
export async function initSwipeSwiper() {
  document.querySelectorAll(".swiper-swipe").forEach((el) => {
    /**---------------------------------------------
     * fadeエフェクトの場合は、loopプロパティはfalseにする
     **-----------------------------------------------*/
    new Swiper(el, {
      modules: [Autoplay, Pagination], // ← ブラウザ環境では削除
      loop: true,
      keyboard: { enabled: false },
      mousewheel: { enabled: false },
      autoplay: {
        delay: 5000,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },

      speed: 1000,
      fadeEffect: {
        crossFade: true, // ← スライドを完全に切り替える（true推奨）
      },

      //loopPreventsSlide: false,
      on: {
        slideChangeTransitionStart: function () {
          //console.log('スライド変更開始:', this.realIndex); // スライドが切り替わり始めた瞬間
        },
        slideChangeTransitionEnd: function () {
          //console.log('スライド変更完了:', this.realIndex); // スライド変更が完了した後
        },
      },
    });
  });
}

// 上記はブラウザ環境では削除
export async function initThumnailSwiper() {
  document.querySelectorAll(".swiper-thumnail").forEach((el) => {
  const elThumbs = el.querySelector('.swiper-thumbs');
  const elMain = el.querySelector('.swiper-main');
  const thumbs = new Swiper(elThumbs,{
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
  });

  const swiperMain = new Swiper(elMain,{
    modules: [Navigation, Pagination, Scrollbar, Autoplay,Thumbs],
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    scrollbar: {
      el: '.swiper-scrollbar',
    },
    keyboard: { enabled: true },
    mousewheel: { enabled: true },
    autoplay: {
      delay: 5000,
    },
    speed: 1000,
    fadeEffect: {
      crossFade: true
    },
    thumbs:{
      swiper: thumbs
    },
    loop: true,
  });







  });
}

export const instaSwiper = async () => {
  const swiper = new Swiper(".insta-swiper", {
    modules: [Autoplay, Pagination],
    loop: true,
    slidesPerView: 4,
    spaceBetween: 30,
    keyboard: { enabled: false },
    mousewheel: { enabled: true },
    autoplay: {
      delay: 5000,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    speed: 1000,
    fadeEffect: {
      crossFade: true, // ← スライドを完全に切り替える（true推奨）
    },
    //loopPreventsSlide: false,
    on: {
      slideChangeTransitionStart: function () {
        //console.log('スライド変更開始:', this.realIndex); // スライドが切り替わり始めた瞬間
      },
      slideChangeTransitionEnd: function () {
        //console.log('スライド変更完了:', this.realIndex); // スライド変更が完了した後
      },
    },
  });
};
